<template>
	<v-empty-state
		headline="Збитковіть страхувальника"
		title="Отримання інформації по збитковості страхувальника з МТСБУ"
		icon="mdi-car"
	>
		<template v-slot:text>
			<div class="text-medium-emphasis text-caption">
				Платформа для отримання інформації по збитковості страхувальника з урахуванням збитків за договорами ОСЦПВ та ЗК з Моторного транспортного страхового бюро України.
			</div>
		</template>
		<v-container>
			<v-card variant="text">
				<v-card-text>
					<v-form ref="form">
						<v-row>
							<v-col cols="12" md="4" class="d-flex align-center">
								<div class="font-weight-bold">Тип страхування</div>
							</v-col>
							<v-col cols="12" md="8">
								<v-select
									v-model="param.policy_type"
									:items="policytypes"
									variant="outlined"
									density="compact"
									hide-details
									single-line
									flat
									required
								></v-select>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" md="4" class="d-flex align-center">
								<div class="font-weight-bold">РНОКПП Фізичної або ЄДРПОУ юридичної особи або серія та номер паспорту або ID паспорту для фізичних осіб</div>
							</v-col>
							<v-col cols="12" md="8">
								<v-text-field
									v-model="param.ident_code"
									variant="outlined"
									density="compact"
									hide-details="auto"
									single-line
									flat
									required
									clearable
									:rules="[rules.requiredAny]"
									@keydown.ctrl.z="param.ident_code='123456789'"
								></v-text-field>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" md="4" class="d-flex align-center">
								<div class="font-weight-bold">Номер ТЗ</div>
							</v-col>
							<v-col cols="12" md="8">
								<v-text-field
									v-model="param.plate_no"
									variant="outlined"
									density="compact"
									hide-details="auto"
									single-line
									flat
									required
									clearable
									:rules="[rules.requiredAny]"
								></v-text-field>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" md="4" class="d-flex align-center">
								<div class="font-weight-bold">Vin-код ТЗ</div>
							</v-col>
							<v-col cols="12" md="8">
								<v-text-field
									v-model="param.vin"
									variant="outlined"
									density="compact"
									hide-details="auto"
									single-line
									flat
									required
									clearable
									:rules="[rules.requiredAny]"
								></v-text-field>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" md="4" class="d-flex align-center">
								<div class="font-weight-bold">Прізвище фізичної особи або назва юридичної особи</div>
							</v-col>
							<v-col cols="12" md="8">
								<v-text-field
									v-model="param.surname"
									variant="outlined"
									density="compact"
									hide-details
									single-line
									flat
									clearable
								></v-text-field>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" md="4" class="d-flex align-center">
								<div class="font-weight-bold">Ім’я фізичної особи</div>
							</v-col>
							<v-col cols="12" md="8">
								<v-text-field
									v-model="param.given_name"
									variant="outlined"
									density="compact"
									hide-details
									single-line
									flat
									clearable
								></v-text-field>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" md="4" class="d-flex align-center">
								<div class="font-weight-bold">По батькові фізичної особи</div>
							</v-col>
							<v-col cols="12" md="8">
								<v-text-field
									v-model="param.middle_name"
									variant="outlined"
									density="compact"
									hide-details
									single-line
									flat
									clearable
								></v-text-field>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" md="4" class="d-flex align-center">
								<div class="font-weight-bold">Дата початку періоду</div>
							</v-col>
							<v-col cols="12" md="8">
								<v-date-input 
									v-model="param.start_date"
									variant="outlined"
									density="compact"
									hide-details
									single-line
									flat
									clearable
								></v-date-input>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" md="4" class="d-flex align-center">
								<div class="font-weight-bold">Дата кінця періоду</div>
							</v-col>
							<v-col cols="12" md="8">
								<v-date-input 
									v-model="param.end_date"
									variant="outlined"
									density="compact"
									hide-details
									single-line
									flat
									clearable
								></v-date-input>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn prepend-icon="mdi-magnify" variant="tonal" @click="onSearch">
						Пошук
					</v-btn>
				</v-card-actions>
			</v-card>

			<v-divider></v-divider>

			<v-card v-if="oscpv.length"
				title="Внутрішнє страхування"
				flat
			>
				<v-data-table 
					:headers="headersOSCPV"
					:items="oscpv"
					hide-default-footer
					disable-pagination
				>
					<template v-slot:item.event_date="{ item }">
						<span v-if="!item.event_date">{{ $filters.dateFormat(item.event_date) }}</span>
					</template>
				</v-data-table>
			</v-card>

			<v-card v-if="gc.length"
				title="Міжнародне страхування"
				flat
			>
				<v-data-table 
					:headers="headersGC"
					:items="gc"
					hide-default-footer
					disable-pagination
				>
					<template v-slot:item.event_date="{ item }">
						<span v-if="!item.event_date">{{ $filters.dateFormat(item.event_date) }}</span>
					</template>
				</v-data-table>
			</v-card>

			<v-fab v-if="oscpv.length || gc.length"
				color="primary"
				icon="mdi-microsoft-excel"
				class="mr-6 mb-6"
				location_="bottom end"
				size="64"
				app
				appear
				@click="onExcel"
			></v-fab>
		</v-container>

		<v-overlay v-model="loading" contained class="align-center justify-center">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
	</v-empty-state>
</template>


<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import { VDateInput } from 'vuetify/labs/VDateInput'
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default {
	name: 'Loss',
	components: { VDateInput },
	data: () => ({
		filename: 'Збитковіть страхувальника',

		loading: false,

		policytypes: [
			{ title: 'Все', value: 'ALL' },
			{ title: 'Внутрішнє страхування', value: 'OSCPV' },
			{ title: 'Міжнародне страхування', value: 'GC' },
		],

		headersOSCPV: [
			{ id: 1, title: 'Державний номер ТЗ', key: 'plate_no', description: 'Державний номер транспортного засобу за відповідним полісом внутрішнього страхування' },
			{ id: 2, title: 'VIN-код ТЗ', key: 'vin', description: 'VIN-код транспортного засобу за відповідним полісом внутрішнього страхування' },
			{ id: 3, title: 'Серія полісу ВС', key: 'policy_series', description: 'Серія (за наявності) полісу внутрішнього страхування', hint: 'Серія полісу наявна тільки за бланковими договорами. За електронними договорами серія полісу (EP) відсутня.' },
			{ id: 4, title: 'Номер полісу ВС', key: 'policy_no', description: 'Номер полісу, які було знайдено за даними ЦБД МТСБУ' },
			{ id: 5, title: 'Рік початку дії полісу ВС', key: 'start_date', description: 'Рік початку дії полісу внутрішнього страхування' },
			{ id: 6, title: 'Строк дії полісу ВС', key: 'validity_period', description: 'Назва строку дії полісу внутрішнього страхування' },
			{ id: 7, title: 'Страхувальник (назва/ПІБ)', key: 'fullName', description: 'Страхувальник за полісом внутрішнього страхування - назва юридичної особи, або ПІБ фізичної особи' },
			{ id: 8, title: 'Код страхової компанії', key: 'insurer_code', description: 'Код Страховика, який уклав поліс внутрішнього страхування' },
			{ id: 9, title: 'Назва страхової компанії', key: 'insurer_name', description: 'Назва Страховика, який уклав поліс внутрішнього страхування' },
			{ id: 10, title: 'Тип ТЗ (позначення)', key: 'vehicle_type', description: 'Тип Транспортного засобу згідно полісу внутрішнього страхування' },
			{ id: 11, title: 'Марка ТЗ', key: 'vehicle_brand', description: 'Назва мартки Транспортного засобу згідно полісу внутрішнього страхування' },
			{ id: 12, title: 'Повне найменування ТЗ', key: 'vehicle_title', description: 'Повне найменування Транспортного засобу' },
			{ id: 13, title: 'Кількість ДТП (подій)', key: 'insured_events_count', description: 'Кількість ДТП (подій) за полісом внутрішнього страхування' },
			{ id: 14, title: 'Дата ДТП (події)', key: 'event_date', description: 'Дата ДТП (події) за полісом внутрішнього страхування', hint: 'Може бути декілька значень' },
			{ id: 15, title: 'Загальна кількість вимог за полісом ВС', key: 'claims_count', description: 'Загальна кількість вимог за полісом внутрішнього страхування' },
			{ id: 16, title: 'Кількість вимог в роботі (рішення не прийнято)', key: 'claims_in_work_count', description: 'Кількість вимог ВС, за якими рішення ще не прийнято' },
			{ id: 17, title: 'Кількість врегульованих вимог', key: 'settled_claims_count', description: 'Кількість вимог за полісом внутрішнього страхування, які мають статус "Врегульовані шляхом сплати відшкодування" та/або "Врегульовані в інший спосіб"' },
			{ id: 18, title: 'Кількість вимог, за якими відмовлено у виплаті', key: 'refused_claims_count', description: 'Кількість вимог за полісом ВС у статусі "Відмова у виплаті"' },
			{ id: 19, title: 'Нарахована сума відшкодуваня', key: 'total_loss_amount', description: 'Нарахована сума відшкодуваня за полісом внутрішнього страхування' },
			{ id: 20, title: 'Сплачена сума збитку', key: 'paid_loss_amount', description: 'Сплачена сума збитку за полісом внутрішнього страхування' },
			{ id: 21, title: 'Несплачена сума збитку', key: 'reserved_loss_amount', description: 'Сума збитку за полісом, яка нарахована, але ще не сплачена, з урахуванням лімітів відшкодування по типу шкоди (між несплаченою сумою збитку та лімітом відшкодування за відповідним типом збитку обирається менше значення)' },
		],

		headersGC: [
			{ id: 1, title: 'Державний номер ТЗ', key: 'plate_no', description: 'Державний номер транспортного засобу за відповідним полісом міжнародного страхування' },
			{ id: 2, title: 'VIN-код ТЗ', key: 'vin', description: 'VIN-код транспортного засобу за відповідним полісом міжнародного страхування' },
			{ id: 3, title: 'Серія полісу ЗК', key: 'policy_series', description: 'Порожнє поле, введено по аналогії з внутрішнім страхуванням, для створення єдиної процедури' },
			{ id: 4, title: 'Номер полісу ЗК', key: 'policy_no', description: 'Номер полісу по міжнародному страхуванню' },
			{ id: 5, title: 'Рік початку дії полісу ЗК', key: 'start_date', description: 'Рік початку дії полісу міжнародного страхування' },
			{ id: 6, title: 'Строк дії полісу ЗК', key: 'validity_period', description: 'Назва строку дії полісу міжнародного страхування' },
			{ id: 7, title: 'Страхувальник (назва/ПІБ)', key: 'fullName', description: 'Страхувальник за полісом міжнародного страхування - назва юридичної особи, або ПІБ фізичної особи' },
			{ id: 8, title: 'Код страхової компанії', key: 'insurer_code', description: 'Код Страховика, який уклав поліс міжнародного страхування' },
			{ id: 9, title: 'Назва страхової компанії', key: 'insurer_name', description: 'Назва Страховика, який уклав поліс міжнародного страхування' },
			{ id: 10, title: 'Тип ТЗ (позначення)', key: 'vehicle_type', description: 'Тип Транспортного засобу згідно полісу міжнародного страхування' },
			{ id: 11, title: 'Марка ТЗ', key: 'vehicle_brand', description: 'Назва мартки Транспортного засобу згідно полісу міжнародного страхування' },
			{ id: 12, title: 'Повне найменування ТЗ', key: 'vehicle_title', description: 'Повне найменування Транспортного засобу' },
			{ id: 13, title: 'Кількість ДТП (подій)', key: 'insured_events_count', description: 'Кількість ДТП (подій) за полісом міжнародного страхування' },
			{ id: 14, title: 'Дата ДТП (події)', key: 'event_date', description: 'Дата ДТП (події) за полісом міжнародного страхування', hint: 'Може бути декілька значень' },
			{ id: 15, title: 'Загальна кількість вимог за полісом ЗК', key: 'claims_count', description: 'Загальна кількість вимог за полісом міжнародного страхування' },
			{ id: 16, title: 'Кількість вимог в роботі (рішення не прийнято)', key: 'claims_in_work_count', description: 'Кількість вимог ЗК, не було виплат та не проставлена ознака відмови у виплаті' },
			{ id: 17, title: 'Кількість вимог, за якими були виплати', key: 'settled_claims_count', description: 'Кількість вимог за полісом міжнародного страхування, за якими здійснювалися виплати' },
			{ id: 18, title: 'Кількість вимог, за якими відмовлено у виплаті', key: 'refused_claims_count', description: 'Кількість вимог за полісом міжнародного страхування, за якими проставлена ознака відмови у виплаті' },
			{ id: 19, title: 'Загальна сума збитку за міжнародним полісом в євро (на поточну дату)', key: 'total_loss_amount', description: 'Сума всіх вимог за міжнародним полісом в євро' },
			{ id: 20, title: 'Сплачена сума збитку, євро', key: 'paid_loss_amount', description: 'Сплачена сума збитку за полісом внутрішнього страхування в євро' },
			{ id: 21, title: 'Несплачена сума збитку в євро (на поточну дату)', key: 'reserved_loss_amount', description: 'Несплачена сума збитку, це сума: 1) Резерву сформованого врегулювальником в євро (на поточну дату); + (плюс) 2) Несплаченої суми вимог в євро (на поточну дату);' },
		],
	}),

	computed: {
		...mapGetters('Loss', [ 'param', 'data' ]),

		oscpv(){
			return this.data?.oscpv ? this.data.oscpv : [] 
		},

		gc(){
			return this.data?.gc ? this.data.gc : [] 
		},

		rules() {
			return {
				required: (value) => !!value || this.$vuetify.locale.t('$vuetify.rule.required'),
				requiredAny: (value) => !!this.param.ident_code || !!this.param.plate_no || !!this.param.vin || 'Хоча б одне з полів повинно бути заповнене',
			}
		},
	},

	created() {
		//console.log(this.$options.name, 'vcreated')

		let access_token = localStorage.getItem('M-Api-Key')
		if(access_token) {
			axios.defaults.headers.common['M-Api-Key'] = access_token;
		}

		let token = localStorage.getItem('X-Api-Key')
		if(token) {
			//console.log(this.$options.name,'created', 'token', token)
			axios.defaults.headers.common['X-Api-Key'] = token;
			this.setLogin(true)
		} else {
			this.setLogin(false)
			this.$router.push({ name: 'Login' }).catch(err => {})
		}

		this.param.policy_type  = 'ALL';
	},

	methods: {
		...mapActions(['setLogin', 'showMessage']),
		...mapActions('Loss', ['setData']),

		onSearch() {
			//console.log(this.$options.name, 'onSearch','param', this.param)

			this.setData()

			var that = this
			this.$refs.form.validate().then(({ valid: isValid }) => {
				if(isValid) {
					this.loading = true
					axios.post(`/mtsbu/breakEvenReport`, this.param).then(response => {
						//console.log(that.$options.name, 'ononSearchOK','response.data', response.data)
						that.setData(response.data)

						if(response.data?.access_token) {
							let access_token = response.data.access_token;
							localStorage.setItem('M-Api-Key', access_token)
							axios.defaults.headers.common['M-Api-Key'] = access_token;
						}

						if(response.data?.errorMessage) {
							this.showMessage(response.data)
						}
					}, error => {
						console.log('error', error)

						this.showMessage(error)
					}).finally(() => {
						this.loading = false
					});
				}
			})
		},

		onExcel() {
			//console.log(this.$options.name,  'onCard', 'direction', direction) 

			const workbook = XLSX.utils.book_new();

			const worksheet = XLSX.utils.json_to_sheet(this.oscpv);
			XLSX.utils.book_append_sheet(workbook, worksheet, 'OSCPV');

			const worksheet2 = XLSX.utils.json_to_sheet(this.gc);
			XLSX.utils.book_append_sheet(workbook, worksheet2, 'GC');

			const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
			const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
			saveAs(blob, this.filename + '.xlsx');
		}
	},
}
</script>
